import React from 'react';
import { Route, Routes } from 'react-router-dom';

import routes from '../routes/routes';

import StyledApp from './styles';

function App() {
  return (
    <StyledApp>
      <Routes>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Routes>
    </StyledApp>
  );
}

export default App;
